// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Smile = function Smile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#smile-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.125 10a8.125 8.125 0 1 0-16.25 0 8.125 8.125 0 0 0 16.25 0M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0m6.938 2.426A4.12 4.12 0 0 0 10 13.75a4.12 4.12 0 0 0 3.063-1.324.938.938 0 0 1 1.378 1.27 5.98 5.98 0 0 1-4.437 1.929 5.96 5.96 0 0 1-4.438-1.93.935.935 0 0 1 .055-1.324.934.934 0 0 1 1.324.055zM5.64 8.125a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m7.5-1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "smile-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
